/**
 * Side-effect module: registers every built-in game. Import once from the app entry. Players
 * are lazy, so the puzzle pages never download a game.
 */
import { fallingBlocksModule } from "./falling-blocks/module";
import { klondikeModule } from "./klondike/module";
import { mergeTilesModule } from "./merge-tiles/module";
import { mineFieldModule } from "./mine-field/module";
import { registerGame } from "./registry";
import { snakeModule } from "./snake/module";

// The admin's games list offers them in this order.
registerGame(fallingBlocksModule);
registerGame(mergeTilesModule);
registerGame(snakeModule);
registerGame(mineFieldModule);
registerGame(klondikeModule);
